import { render, staticRenderFns } from "./GeoLocationNotification.vue?vue&type=template&id=bd095fb2&"
import script from "./GeoLocationNotification.vue?vue&type=script&lang=js&"
export * from "./GeoLocationNotification.vue?vue&type=script&lang=js&"
import style0 from "./GeoLocationNotification.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GeoLocationNotification.vue"
export default component.exports